import React from 'react';
import { useSelector } from 'react-redux';
import { cpfMask } from '../../../../services/mask';
import { ApplicationState } from '../../../../store';
import RefuseSelect from '../RefuseSelect';
import './styles.scss';
const PersonalIformantion: React.FC = () => {
  const driver = useSelector((state: ApplicationState) => state.driver);
  return (
    <div className="containerIformation">
      <div className="personal-info">
        <h6>Nome</h6>
        <p>{driver?.username}</p>
        <h6>Email</h6>
        <p>{driver?.email}</p>
        <h6>CPF</h6>
        <p>{!!driver.cpf && cpfMask(driver.cpf)}</p>

        <h6>Telefone</h6>
        <p>{driver?.phoneNumber}</p>
      </div>
      <RefuseSelect step={1} />
    </div>
  );
};

export default PersonalIformantion;
